import signInBanner from "../../../assets/auth/signUp.png";
import "./rightScreen.scss";
const RightScreen = () => {
    return <div style={{ backgroundImage: `url(${signInBanner})` }} className="signIn-rightScreen-container"></div>;
};
export default RightScreen;
